import React from "react";
import "./css/about.css";
const About = () => {
  return (
    <div className="aboutmain" id="about">
      <div className="abouttop">
        <h2>About Me</h2>
        <p className="abouttext">
          As a skilled Full Stack Developer, I am passionate about software
          development and committed to continuous learning. I am seeking a
          challenging and rewarding career that values innovation and teamwork
          and allows me to contribute my knowledge and skills to the
          organization.
        </p>
      </div>
    </div>
  );
};

export default About;
